<script>
export default {
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
    slice: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
    }
  },
  computed: {
    buttonText() {
      if (this.fields.btnText.text)
        return this.fields.btnText.text

      return 'Book Now'
    },

  },
  mounted() {
    defineSlice({
      preview: 'SlicesBookingBookNowButton.jpg',
      description: 'Book Now Button',
      fields: { btnText: { type: 'text', label: 'Button Text', editorLabel: true } },
      name: { label: 'Book Now Button', group: 'Booking', layouts: ['Atlantisbahamas'] },
      tags: ['Booking'],
      templates: [{ label: 'Book Now Button', fields: { btnText: { value: 'Book Now' } } }],
    })
  },
}
</script>

<template>
  <div>
    <BookingBookNow>
      <button class="btn-blue" v-html="buttonText" />
    </BookingBookNow>
  </div>
</template>
